var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "#DBEBFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0078 43.25C38.221 43.25 43.2578 38.2132 43.2578 32C43.2578 25.7868 38.221 20.75 32.0078 20.75C25.7946 20.75 20.7578 25.7868 20.7578 32C20.7578 38.2132 25.7946 43.25 32.0078 43.25Z",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7578 22.6453L26.8219 16.7766C26.8742 16.4885 27.026 16.228 27.2507 16.0404C27.4754 15.8528 27.7588 15.75 28.0516 15.75H35.9641C36.2568 15.75 36.5402 15.8528 36.765 16.0404C36.9897 16.228 37.1414 16.4885 37.1938 16.7766L38.2578 22.6453",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7578 41.3555L26.8219 47.2242C26.8742 47.5122 27.026 47.7728 27.2507 47.9604C27.4754 48.148 27.7588 48.2507 28.0516 48.2508H35.9641C36.2568 48.2507 36.5402 48.148 36.765 47.9604C36.9897 47.7728 37.1414 47.5122 37.1938 47.2242L38.2578 41.3555",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0078 25.75V32H38.2578",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.aab4d29b3966b31c375b9f8139b8ee72.svg";
export { ForwardRef as ReactComponent };